/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';

import { Container, Header, Challenge, Main } from './styles';

import api from '~/services/api';
import history from '~/services/history';

export default function Admin() {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    async function getModules() {
      const { data } = await api.get('/modules');

      setModules(data);
    }
    getModules();
  }, []);

  return (
    <>
      <Header>
        <button type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </button>
        <button type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </button>

        <button type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </button>

        {/* <button type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </button> */}

        <button type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </button>

        <button type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </button>

        <button type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </button>

        <button type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </button>
      </Header>
      <Container>
        {modules.map((module) => (
          <Main key={module.id}>
            <h1>
              #{module.id} - Module: {module.title}
            </h1>
            <h2>Subject: {module.subject.title}</h2>
            <h2>Level: {module.level.title}</h2>
            {/* <h3>Cards (Quantidade: {module.contents.length})</h3>
            {module.contents.map(card => (
              <Card key={card.id}>
                <p>
                  {card.source} - {card.channel} : {card.content}
                </p>
                <a href={`${card.link}`}>{card.link}</a>
              </Card>
            ))} */}
            <h3>Challenges (Quantidade: {module.challenges.length})</h3>
            {module.challenges.map((challenge) => (
              <Challenge key={challenge.id}>
                <p>Titulo da Pergunta: {challenge.title}</p>
                <p>Pergunta: {challenge.question}</p>
                <p style={{ fontSize: 14, paddingLeft: 50 }}>
                  Texto de Ajuda: {challenge.help}
                </p>
              </Challenge>
            ))}
          </Main>
        ))}
      </Container>
    </>
  );
}
